import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/balance/";

//辅助价格表
export function get_priceCurrencyConvert(config) {
  return XtAxios4.get(URL + `public/price/currency/convert`, config);
}
//币种配置表
export function get_currencies(config) {
  return XtAxios4.get(URL + `public/currencies`, config);
}
//推荐币种配置表
export function get_recommendedCurrencies(config) {
  return XtAxios4.get(URL + `public/v2/currencies`, config);
}
export function get_currencyInfoOne(currency, config) {
  return XtAxios4.get(URL + `public/currency-info/${currency}`, config);
}
//现货资产
export function get_balances(config) {
  return XtAxios4.get(URL + `balances`, config);
}
export function get_leverBalance(config) {
  return XtAxios4.get(URL + `lever/balance`, config);
}
export function get_leverBalances(config) {
  return XtAxios4.get(URL + `lever/balances`, config);
}
//获取总资产
export function get_balanceTotal(config) {
  return XtAxios4.get(URL + `balance/total`, config);
}
// 获取带ai跟单的总资产
export function get_balanceTotalWithAiFollow(config) {
  return XtAxios4.get(URL + `balance/total/with-ai-follow`, config);
}
